import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { api, mediaUrl } from "@/lib/api";

const SERVICE_LABEL = { curhat: "Curhat", sleepcall: "Sleepcall", chat: "Chat Buddy" };
const INTERVAL_MS = 4500;

export function FeaturedSlider({ fallbackImg, className = "" }) {
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(0);
  const [paused, setPaused] = useState(false);
  useEffect(() => { api.get("/featured").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  useEffect(() => {
    if (paused || items.length < 2) return undefined;
    const t = setInterval(() => setIdx((i) => (i + 1) % items.length), INTERVAL_MS);
    return () => clearInterval(t);
  }, [paused, items.length]);
  const current = items[idx];
  return (
    <div className={`photo-card ${className}`} onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)} data-testid="featured-slider">
      {items.length === 0 && <img src={fallbackImg} alt="Talent Sudut Nadi" className="absolute inset-0 w-full h-full object-cover" data-testid="featured-fallback" />}
      {items.map((t, i) => (
        <img key={t.id} src={mediaUrl(t.avatar_url)} alt={t.name} loading={i === 0 ? "eager" : "lazy"}
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ease-out ${i === idx ? "opacity-100" : "opacity-0"}`} data-testid={`featured-slide-${i}`} />
      ))}
      {items.length > 1 && (
        <div className="absolute top-6 right-6 flex gap-1.5" data-testid="featured-dots">
          {items.map((t, i) => <button key={t.id} type="button" onClick={() => setIdx(i)} aria-label={`Foto ${i + 1}`} className={`h-2.5 rounded-full transition-all duration-500 ${i === idx ? "w-6 bg-white" : "w-2.5 bg-white/60 hover:bg-white/90"}`} data-testid={`featured-dot-${i}`} />)}
        </div>
      )}
      {current && (
        <Link to={`/talent/${current.id}`} className="absolute left-5 right-5 bottom-5 flex items-end justify-between gap-3 rounded-2xl bg-white/85 backdrop-blur-md px-4 py-3 text-neutral-900 transition-colors hover:bg-white" data-testid="featured-caption">
          <span className="min-w-0">
            <span className="block font-heading text-lg font-semibold leading-tight truncate" data-testid="featured-name">{current.name}</span>
            <span className="block text-xs text-neutral-600 truncate">{current.service_ids.map((s) => SERVICE_LABEL[s] || s).join(" · ")}</span>
          </span>
          {current.rating_count > 0 && <span className="shrink-0 inline-flex items-center gap-1 text-sm font-medium"><Star size={14} className="text-amber-500 fill-amber-400" strokeWidth={1.5} />{Number(current.rating_avg).toFixed(1)}</span>}
        </Link>
      )}
    </div>
  );
}
